import { apiCall } from "../service/api-service";

export const getCallsListApi = async (params) => {
  return apiCall("GET", `web/call${params}`);
};

export const createCallsApi = async (data) => {
  return apiCall("POST", "web/call", data);
};

export const UpdateCallsApi = async (data, id) => {
  return apiCall("PUT", `web/call/${id}`, data);
};

export const getCallDetailsApi = async (id) => {
  const response = await apiCall("GET", `web/call/edit/${id}`);
  return response.data;
};

export const getCallDataApi = async (id) => {
  const response = await apiCall("GET", `web/call/view/${id}`);
  return response.data;
};

export const getCallData = async (id) => {
  return getCallDataApi(id);
};

export const getReminderListApi = async (params) => {
  return apiCall("GET", `web/get_call_reminder${params}`);
};

export const getDeleteTeamCallApi = async (deleteUrl, body) => {
  return apiCall("DELETE", deleteUrl, body);
};

export const bulkDeleteCallApi = async (payload) => {
  const data = Array.isArray(payload) ? { id: payload } : payload;
  return apiCall("DELETE", "web/call/bulkdelete", data);
};

export const getUpcomingCallRemindersApi = async () => {
  return apiCall("GET", "web/call_upcoming_reminders");
};

export const getTodayCallsApi = async () => {
  return apiCall("GET", "web/call_today");
};

export const getWeekCallsApi = async () => {
  return apiCall("GET", "web/call_week");
};

export const getCallAiSummaryApi = async (id, payload) => {
  return apiCall("POST", `web/call/ai_summary/${id}`, payload);
};
